import React from 'react';
import './css/SideBox.css'
import { Typography, IconButton, Tooltip, Fade } from '@material-ui/core';
import { Link, LinkOff } from '@material-ui/icons';
import ArticleCollection from './ArticleCollection';
import Comparison from './Comparison';
import DescriptionList from './DescriptionList';

export default class InformationBox extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      data:[]
    }
  }

  componentDidUpdate(prevProps) {
    const dataLoaded = prevProps.data !== this.props.data;

    if (dataLoaded){
      this.setState(() => {
        return {
          data: this.props.data
        }
      });
    }
  }

  render() {
    const { program, provinces, data } = this.props;

    let title;
    if (program) title = program.name;
    else if (provinces.length === 1) title = provinces[0];
    else if (provinces.length > 2) title = 'Selected Provinces';
    else title = provinces[0] + ' & ' + provinces[1];

    const url = program && program.link;
    const content = program ? program.description : 'Please select a Program';
    const articles = <ArticleCollection data={this.state.data[0]} />;
    const list = program && program.list;

    const description = (
      <div>
        <Typography variant="h6">Description</Typography>
        <Fade in={Boolean(program)} timeout={{ enter: 1000 }} >
          <div>
            <Typography variant="body1" gutterBottom>{content}</Typography>
            {list && <DescriptionList data={list} />}
          </div>
        </Fade>
      </div>
    );
    
    const isProgram = () => {
      if (program){
        return (description)
      } 

      else if (provinces) {
        if (provinces.length > 1)  return <Comparison data = {data}/>
        else return (articles);
      }

      else {
        return null;
      }
    };


    return (
      <div className="infoContainer">
        {/* <div className="placeholder">
          <Typography variant="h4" align="center">Ê•â€¢á´¥â€¢Ê”</Typography>
        </div> */}
        <Typography align="center" variant="h5">{title}</Typography>
        { this.props.program && (
          <div className="programInfoContainer" align="center">
            <Tooltip 
              title={url ? "Open Program Webpage in New Tab" : "No Link Found"}
              placement="left"
            >
              <IconButton 
                disabled={!url} 
                href={url}
                target="_blank"
              >
                {url ? <Link /> : <LinkOff />}
              </IconButton>
            </Tooltip>
          </div>)
        }
        {isProgram()}
      </div>
    );
  }
}